
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 85.333 512 341.333"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M0 85.333h512V426.67H0z"}}),_c('path',{attrs:{"fill":"#D80027","d":"M288 85.33h-64v138.666H0v64h224v138.666h64V287.996h224v-64H288z"}}),_c('g',{attrs:{"fill":"#0052B4"}},[_c('path',{attrs:{"d":"M393.785 315.358L512 381.034v-65.676zM311.652 315.358L512 426.662v-31.474l-143.693-79.83zM458.634 426.662l-146.982-81.664v81.664z"}})]),_c('path',{attrs:{"fill":"#FFF","d":"M311.652 315.358L512 426.662v-31.474l-143.693-79.83z"}}),_c('path',{attrs:{"fill":"#D80027","d":"M311.652 315.358L512 426.662v-31.474l-143.693-79.83z"}}),_c('g',{attrs:{"fill":"#0052B4"}},[_c('path',{attrs:{"d":"M90.341 315.356L0 365.546v-50.19zM200.348 329.51v97.151H25.491z"}})]),_c('path',{attrs:{"fill":"#D80027","d":"M143.693 315.358L0 395.188v31.474l200.348-111.304z"}}),_c('g',{attrs:{"fill":"#0052B4"}},[_c('path',{attrs:{"d":"M118.215 196.634L0 130.958v65.676zM200.348 196.634L0 85.33v31.474l143.693 79.83zM53.366 85.33l146.982 81.664V85.33z"}})]),_c('path',{attrs:{"fill":"#FFF","d":"M200.348 196.634L0 85.33v31.474l143.693 79.83z"}}),_c('path',{attrs:{"fill":"#D80027","d":"M200.348 196.634L0 85.33v31.474l143.693 79.83z"}}),_c('g',{attrs:{"fill":"#0052B4"}},[_c('path',{attrs:{"d":"M421.659 196.636L512 146.446v50.19zM311.652 182.482V85.331h174.857z"}})]),_c('path',{attrs:{"fill":"#D80027","d":"M368.307 196.634L512 116.804V85.33L311.652 196.634z"}})])
          )
        }
      }
    